import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import ForgotPassword from '../ForgotPassword'
import Input from "@material-ui/core/Input";
import Button from "@material-ui/core/Button";
// import Select from "@material-ui/core/Select";
// import MenuItem from "@material-ui/core/MenuItem";
// import { Icon } from "@material-ui/core";
import { loginStatus } from "../../actions/loginActions";
import { Checkbox, FormControl, FormControlLabel, Typography, Grid } from "@material-ui/core";
import CircularProgress from '@material-ui/core/CircularProgress';
import Link from "../Helpers/Link";
import { Redirect } from "react-router";
import TitledForm from "../Helpers/TitledForm";

export default class Login extends Component {

    constructor( props ) {
        super( props );
        this.onSubmit = this.onSubmit.bind( this );
        this.onChange = this.onChange.bind( this );
        this.state = {
            email: "",
            password: "",
            remember: "",
            passwordDialog: false
        }
    }

    onSubmit( e ) {
        this.props.onSubmit({
            email: this.state.email,
            password: this.state.password
        });
        if ( e )
            e.preventDefault();
    }

    componentDidMount() {
        this.props.clearStatus();
    }

    componentWillUnmount() {
        this.props.clearStatus();
    }

    onChange( value, name ) {
        this.setState({
            [name]: value
        });
    }

    renderLoginStatus( status ) {
        switch ( status ) {
            case loginStatus.fail:
                return (
                    <Typography
                        variant="subtitle1"
                        color="error"
                        align="center"
                        >
                        The email or password you provided was wrong
                    </Typography>
                );
            case loginStatus.notVerified:
                return (
                    <Typography
                        variant="subtitle1"
                        color="error"
                        align="center"
                        >
                        User not verified. Check your email for the verification link.
                    </Typography>
                );
            case loginStatus.success:
                return (
                    <div>
                        <Typography
                            variant="subtitle1"
                            color="primary"
                            align="center"
                        >
                            Logged in successfully!
                        </Typography>
                        <Redirect push to="/user/matches"/>
                    </div>
                );
            default: return(
                <Typography variant="subtitle1">
                    &nbsp;
                </Typography>
            );
        }
    }

    render() {
        return (
            <Fragment>
                <ForgotPassword
                    open={this.state.passwordDialog}
                    email={this.state.email}
                    handleClose={() => this.onChange(false, 'passwordDialog')}
                    onChange={e => this.onChange(e.target.value, 'email')}
                />
                <TitledForm
                    title="Welcome back to Sopia! Please login to your account"
                    form={
                        <form onSubmit={this.onSubmit} className="Content-form">
                            <FormControl
                                required
                                error={this.props.status === loginStatus.fail}
                            >
                                <Input
                                    placeholder="Email"
                                    name="email"
                                    type="email"
                                    value={this.state.email}
                                    onChange={(e) => this.onChange( e.target.value, "email" )}
                                    />
                            </FormControl>
                            <FormControl
                                required
                                error={this.props.status === loginStatus.fail}
                            >
                                <Input
                                    placeholder="Password"
                                    name="password"
                                    type="password"
                                    value={this.state.password}
                                    onChange={(e) => this.onChange( e.target.value, "password" )}
                                    />
                            </FormControl>
                            {this.renderLoginStatus( this.props.status )}
                            <Grid container direction="row"  justifyContent="space-between">
                                <FormControlLabel
                                    label="Remember me"
                                    control={
                                        <Checkbox
                                            value={this.state.remember}
                                            onChange={(e) => this.onChange( e.target.value, "remember" )}
                                        />
                                    }
                                />
                                <Button
                                    variant="text"
                                    color="secondary"
                                    onClick={() => this.onChange(true, 'passwordDialog')}
                                >
                                    Forgot Password
                                </Button>
                            </Grid>
                            <Grid container direction="row"  justifyContent="space-around">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    disabled={this.props.status === loginStatus.inProgress}
                                >
                                    Login
                                </Button>
                                <Link to="/signup">
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        size="large"
                                    >
                                        Sign Up
                                    </Button>
                                </Link>
                            </Grid>
                            {this.props.status === loginStatus.inProgress &&
                                <Grid container  justifyContent="center">
                                    <CircularProgress color="primary"/>
                                </Grid>
                            }
                        </form>
                    }
                />
            </Fragment>
        );
    }

}

Login.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired
}